import FormDocument, { FormDocumentStatus } from "./form-document";
import FormDefinition from '../form-definition/form-definition';
import { SyncStatus } from 'src/app/entities/SyncStatus';
import { FormDocumentIdentifier } from './form-document-identifier';

type FormDocumentSummaryType = Pick<
  FormDocument,
  | "RecordId"
  | "FormDefinition"
  | "DocumentId"
  | "CreatedDate"
  | "ModifiedDate"
  | "Status"
  | "syncStatus"
  | "Identifiers"
  | "artifactGenerated"
>;
export class FormDocumentSummary implements FormDocumentSummaryType {
  RecordId: number;
  FormDefinition: FormDefinition;
  DocumentId: string;
  CreatedDate: string;
  ModifiedDate: string;
  Status: FormDocumentStatus;
  syncStatus: SyncStatus;
  Identifiers: FormDocumentIdentifier[];
  artifactGenerated: boolean;
  constructor(record: FormDocument) {
    this.RecordId = record.RecordId;
    this.FormDefinition = record.FormDefinition;
    this.DocumentId = record.DocumentId;
    this.CreatedDate = record.CreatedDate;
    this.ModifiedDate = record.ModifiedDate;
    this.Status = record.Status;
    this.syncStatus = record.syncStatus;
    this.Identifiers = record.Identifiers;
    this.artifactGenerated = record.artifactGenerated;
  }
}
